import React from 'react'
import PropTypes from 'prop-types'
import { css, withTheme } from 'styled-components'

import { Glyph, Checkbox } from '@liquid-design/liquid-design-react'
import { getClassName } from './utils'

const getStyledCSS = iconProps => css`
  ${props => css`
    transition: ${props.theme.transition};
    transform: rotate(${iconProps.pointingDown ? 0 : 180}deg);
  `};
`

const ArrowIconBase = ({ pointingDown, theme, inactive, ...props }) => (
  <Glyph
    name="arrowTop"
    styledCSS={getStyledCSS({ pointingDown })}
    color={inactive ? theme.colors.sensitiveGrey.darkest : undefined}
    {...props}
  />
)

ArrowIconBase.propTypes = {
  theme: PropTypes.object.isRequired,
  pointingDown: PropTypes.bool,
  inactive: PropTypes.bool,
}

ArrowIconBase.defaultProps = {
  pointingDown: false,
  inactive: false,
}

export const ArrowIcon = withTheme(ArrowIconBase)

const TABLE_AUX_COMPONENT_CLASSNAME_BASE = 'TableAuxComponent'
export const getTableAuxComponentClassName = name =>
  getClassName({
    name: `${TABLE_AUX_COMPONENT_CLASSNAME_BASE}--${name}`,
  })

export const getAuxComponent = ({
  rowInfoArrow,
  checkbox,
  checkboxDisabled,
  size,
}) => {
  let Component
  let componentName
  const ArrowIconCmp = props => <ArrowIcon size={25.7} {...props} />

  const CheckboxIcon = props => (
    <Checkbox iconSize={19} {...props} disabled={checkboxDisabled} />
  )
  if (rowInfoArrow) {
    Component = ArrowIconCmp
    componentName = 'Arrow'
  } else if (checkbox) {
    Component = CheckboxIcon
    componentName = 'Checkbox'
  }
  return (
    Component &&
    (props => (
      <div
        className={getTableAuxComponentClassName(componentName)}
        style={{ paddingRight: '8px' }}
      >
        <Component {...props} />
      </div>
    ))
  )
}
